module.exports = __webpack_public_path__ + "48405ec9c818a39cc89a11f63990d9fa.svg";